// extracted by mini-css-extract-plugin
export default {"container":"O42mSJIcEx7jUXB5xkgd","item":"wMKz6ONt0xcCGTHHDqbd","title":"A8_jMEsKWMswxiDHXvKw","body":"DLRNFmsEnhJUmMvmWj0r","footer":"wDYPdN5loYaF2qI_VHD6"};